import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        borderRadius: '6px'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        height: '40px',
        padding: '0 8px'
    },
    announcementItem: {
        padding: '12px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
    },
    announcementHeader: {
        fontWeight: 'bold',
        marginBottom: '8px',
    },
    announcementMessage: {
        fontSize: '14px',
        marginBottom: '8px'
    },
    announcementImage: {
        maxWidth: '100%',
        maxHeight: '200px',
        marginTop: '8px',
        borderRadius: '24px'
    },
    emptyContainer: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    clickable: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    }

}))
